/**
 * Range date picker init
 *
 * @param elStart - start date range picker element
 * @param elEnd - end date range picker element
 */
let moment = require('moment');
import '../../../node_modules/bootstrap-daterangepicker/daterangepicker'

export class Datatime_picker {

    constructor(wrapRange){
        this.wrapRange = $(wrapRange);
    }

    /**
     * initialize data time picker
     */
    init(){
        let _this = this;
        /**
         * Add language by locale
         */
        moment.locale(app.locale);

        let curTime = $(_this.wrapRange).data('time'); // add time
        let curFormat = $(_this.wrapRange).data('format'); // add date
        $(this.wrapRange).daterangepicker({
            timePicker: curTime,
            timePicker24Hour: curTime,
            timePickerIncrement: 30,
            autoUpdateInput: false,
            startDate: moment().startOf('hour'),
            endDate: moment().startOf('hour').add(32, 'hour'),
            locale: {
                format: curFormat,
            }
        });

        /**
         * Add data into input's on change
         */
        $(this.wrapRange).on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format(curFormat));
            $(this).siblings('.js_datetime_picker-end').val(picker.endDate.format(curFormat));
        });

    }

}


// WEBPACK FOOTER //
// ./js/script/components/data_range.js